import { Schoolbreak } from '@libs/types/Schoolbreak.ts'
import { RootState } from '@store/store.ts'

export const getSchoolBreakListSelector = (state: RootState): Schoolbreak[] => {
  return state.schoolBreaks.schoolBreaksList ?? []
}
